// API chatbota v2 (backend: app/api/endpoints/chat_v2.py)
import { APP_API_BASE } from "./apiConfig";
import { getAuthHeaders } from "./authService";

const BASE = `${APP_API_BASE}/api/chat`;

async function handle(res) {
  let json = null;
  try {
    json = await res.json();
  } catch (e) {
    json = null;
  }
  if (!res.ok) {
    const detail = json?.detail;
    const msg = typeof detail === "string" ? detail : `Chyba serveru (${res.status})`;
    const err = new Error(res.status === 402 ? "Nemáte dostatek kreditů." : msg);
    err.status = res.status;
    throw err;
  }
  return json;
}

export async function sendChatMessage(text, conversationId, jobId) {
  const res = await fetch(`${BASE}/message`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify({ text, conversation_id: conversationId || null, job_id: jobId || null }),
  });
  return handle(res);
}

export async function listConversations() {
  const res = await fetch(`${BASE}/conversations`, { headers: { ...getAuthHeaders() } });
  return handle(res);
}

export async function getConversation(id) {
  const res = await fetch(`${BASE}/conversations/${id}`, { headers: { ...getAuthHeaders() } });
  return handle(res);
}

// Průběžná odpověď (SSE přes fetch): onEvent dostává {type: start|tool|delta|done|error, ...}
export async function streamChatMessage(text, conversationId, jobId, onEvent) {
  const res = await fetch(`${BASE}/message/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify({ text, conversation_id: conversationId || null, job_id: jobId || null }),
  });
  if (!res.ok || !res.body) {
    await handle(res);
    throw new Error(`Chyba serveru (${res.status})`);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf("\n\n")) >= 0) {
      const chunk = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      const line = chunk.split("\n").find((l) => l.startsWith("data: "));
      if (line) onEvent(JSON.parse(line.slice(6)));
    }
  }
}
